import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import aboutus from '@/components/aboutus'
import product from '@/components/product'
import product_m from '@/components/product_m'
import aboutus_m from '@/components/aboutus_m'
import recruit from '@/components/recruit'
import recruit_m from '@/components/recruit_m'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/product_m',
      name: 'product_m',
      component: product_m
    },
    {
      path: '/aboutus_m',
      name: 'aboutus_m',
      component: aboutus_m
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    },
    {
      path: '/recruit_m',
      name: 'recruit_m',
      component: recruit_m
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js